// extracted by mini-css-extract-plugin
export var bigText = "MainHero-module--big-text--8f19a";
export var left = "MainHero-module--left--31e29";
export var mainHero = "MainHero-module--main-hero--dcce7";
export var richText = "MainHero-module--rich-text--1196d";
export var right = "MainHero-module--right--02e57";
export var rightImage = "MainHero-module--right-image--e4ea6";
export var text = "MainHero-module--text--c0612";
export var title = "MainHero-module--title--dc5c0";
export var wrapper = "MainHero-module--wrapper--250ad";